export const INVALID = 'Invalid';
export const VALID = 'Valid';
